import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OrderByWaterLevelPipe } from "./order-by-water-level.pipe";

@NgModule({
  declarations: [OrderByWaterLevelPipe],
  imports: [CommonModule],
  exports: [OrderByWaterLevelPipe],
})
export class OrderByWaterLevelModule {}
